import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    playIcon: {
      width: 21,
      height: 24,
      [theme.breakpoints.up('sm')]: {
        width: 33,
        height: 37,
        marginLeft: 8,
      },
    },
  }),
);
export default useStyles;
